import React, { memo } from 'react';

// helpers
import useTranslation from 'hooks/useTranslation';
import { ApplicationCommentsStatus } from 'enums/onboarding/crm';

// components
import StatusLabel from 'components/Typography/StatusLabel';

const STATUS_MAP = {
  info: [],
  warning: [ApplicationCommentsStatus.Open],
  success: [ApplicationCommentsStatus.Resolved],
  error: [],
};

interface IProps {
  status: ApplicationCommentsStatus;
}

const ApplicationCommentStatus = memo(({ status }: IProps) => {
  const { t } = useTranslation('onboarding');

  return (
    <StatusLabel
      statusMap={STATUS_MAP}
      status={status}
      content={t(
        `intake_form.application_review_comments.field_issues.statuses.${status}`,
      )}
    />
  );
});

export default ApplicationCommentStatus;
